<div class="flex flex-col items-center w-full min-h-screen bg-secundary dark:bg-secundary_dark relative">
  <div class="mt-36 lg:mt-24 w-11/12 mb-8">
    <app-navigation-menu
      [items]="menuItems"
      basePath="alerta" 
      contextTitle="EVENTS">
    </app-navigation-menu>
    <router-outlet></router-outlet>
  </div>
</div>
